export default "__VITE_ASSET__DwmbzEzE__"